import React, { createContext, useContext } from 'react';

// Contexte pour les données préchargées (injectées via window.__INITIAL_DATA__ pour les meta OG)
const PreloadedDataContext = createContext({});

export const PreloadedDataProvider = ({ children, data = {} }) => {
  return (
    <PreloadedDataContext.Provider value={data}>
      {children}
    </PreloadedDataContext.Provider>
  );
};

export const usePreloadedData = (key) => {
  const context = useContext(PreloadedDataContext);
  return context[key] || null;
};

export default PreloadedDataContext;

